import React from "react";
import { Link, useLocation } from "react-router-dom";

const SalonAtHomeSearch = ({ item }) => {
  const location = useLocation();
  const room_uuid = location.pathname.split("/")[1];

  return (
    <div className="add-post-container add-cart">
      <div className="add-cart-post new spa">
        <div className="">
          <Link
            to={`/${room_uuid}/salon_at_home/${item.salon_at_home_uuid}`}
            className="add-cart-post-inner"
          >
            <span className="img-pnl navigate">
              <img src={item.image} alt={item.name} />
            </span>
            <div className="txt-pnl navigate">
              <h2>{item.name}</h2>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SalonAtHomeSearch;
